import axios from 'axios'

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 15000
})

export function authenticate (username, password) {
  return http.post('login', { username, password })
    .then(response => response.data.token)
}

export function fetchProjects (accountId) {
  return http.get(`accounts/${accountId}/projects`).then(response => response.data)
}

export function fetchTestLinks (projectId) {
  return http.get(`projects/${projectId}/test_links`)
    .then(response => response.data)
}

export function removeTestLink (projectId, testLinkId) {
  return http.delete(`projects/${projectId}/test_links/${testLinkId}`)
    .then(response => response.data)
}

export function createTestLink (projectId, params) {
  return http.post(`projects/${projectId}/test_links`, params)
    .then(res => res.data)
}

export function fetchProject (projectId) {
  return http.get(`projects/${projectId}`).then(response => response.data)
}

export function createProject (accountId, params) {
  return http.post(`accounts/${accountId}/projects`, params)
     .then(res => res.data)
}

export function updateProject (projectId, params) {
  return http.patch(`projects/${projectId}`, params)
     .then(res => res.data)
}

export function removeProject (projectId) {
  return http.delete(`projects/${projectId}`).then(response => response.data)
}

export function fetchConnections (accountId) {
  return http.get(`accounts/${accountId}/connections`).then(response => response.data)
}

export function testCheck (inquiry) {
  return axios({
    url: 'dev/validate',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify(inquiry),
    baseURL: 'https://y2qbczdjz6.execute-api.eu-west-1.amazonaws.com'
  }).then(response => response.data)
}

export function createConnection (accountId, code, name) {
  return http.post(`accounts/${accountId}/connections`, { code, name })
    .then(res => res.data)
}

export function fetchItems (projectId, params = {}) {
  return http.get(`projects/${projectId}/items`, { params }).then(response => response.data)
}

export function fetchPages (projectId, params = {}) {
  return http.get(`projects/${projectId}/pages`, { params }).then(response => response.data)
}

export function fetchEvents (projectId, params = {}) {
  return http.get(`projects/${projectId}/events`, { params }).then(response => response.data)
}

export function fetchGoogleAdsClientAccounts (accountId) {
  return http.get(`accounts/${accountId}/google_ads/client_accounts`).then(response => response.data)
}

export function fetchGoogleCampaigns (accountId, customerId, mccId) {
  return http.get(`accounts/${accountId}/google_ads/campaigns`, { params: { customer_id: customerId, mcc_id: mccId } }).then(response => response.data)
}

export function fetchCustomers (connectionId) {
  return http.get(`connection/${connectionId}/hierarchy`).then(response => response.data)
}

export function fetchInvoices () {
  return http.get('invoices').then(response => response.data)
}

export function fetchAccounts () {
  return http.get('accounts').then(response => response.data)
}

export function fetchUser () {
  return http.get('me').then(response => response.data)
}
